import React, { useState } from 'react'
import 'styles/EditActivityModal.css'
import { getOnChangeFunction } from 'utils'
import ButtonComponent from 'components/common/ButtonComponent'

const EditActivityModal = ({ activity, onClose, onSave }) => {
  const [localActivity, setLocalActivity] = useState({ ...activity })

  const onChange = getOnChangeFunction(setLocalActivity, localActivity)
  const handleSave = () => onSave(localActivity)

  return (
    <div className='edit-activity-modal-overlay'>
      <div className='edit-activity-modal'>
        <div className='pb-3'>
          <h3 className='text-lg font-semibold text-greenPrimary'>Edit Activity</h3>
        </div>

        <div className='edit-activity-content'>
          <div className='activity-details'>
            <h4>Activity Details</h4>

            <div className='form-group'>
              <label>Name *</label>
              <input
                type='text'
                name='activityName'
                value={localActivity.activityName}
                onChange={onChange}
                required
              />
            </div>

            <div className='checkbox-group'>
              <label>
                <input
                  type='checkbox'
                  name='isActive'
                  checked={localActivity.isActive}
                  onChange={onChange}
                />
                Active
              </label>

              <label>
                <input
                  type='checkbox'
                  name='allDevices'
                  checked={localActivity.allDevices}
                  onChange={onChange}
                />
                All Devices
              </label>

              <label>
                <input
                  type='checkbox'
                  name='shared'
                  checked={localActivity.shared}
                  onChange={onChange}
                />
                Shared
              </label>

              <label>
                <input
                  type='checkbox'
                  name='isFullBlock'
                  checked={localActivity.isFullBlock}
                  onChange={onChange}
                />
                Full Block
              </label>
            </div>
          </div>

          <div className='flex justify-end space-x-4 mt-4'>
            <ButtonComponent onClick={onClose} className='px-4 py-2 rounded-lg hover:bg-green-700'>
              Cancel
            </ButtonComponent>
            <ButtonComponent onClick={handleSave} className='bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400'>
              Save
            </ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditActivityModal
